<script>
import { COLLINS_PHM_TIER_3 } from '@/utilities/appConsts'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: Object,
      required: true,
    },
    hasCaptionOption: {
      type: Boolean,
      default: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showEyeballColumn: {
      type: Boolean,
      default: true,
    },
    readOnlyEyeballColumn: {
      type: Boolean,
      default: false,
    },
    airlineTierTypeId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      selectedRows: [],
      visibilityReminderSent: false,
      visibilityConfirmationSent: false,
      defaultPageSizes: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
      defaultPageSizeSelected: 10,
      previewCaption: this.data.caption,
    }
  },
  computed: {
    getGrids() {
      return this.data.grids
    },
    getSectionTitle() {
      return this.data.sectionTitle
    },
    getGridSelections() {
      return this.data
        ? this.data.selectedRows
          ? this.data.selectedRows
          : []
        : []
    },
  },

  watch: {
    caption(newValue) {
      this.previewCaption = newValue
    },
  },

  mounted: function () {
    this.previewCaption = this.data.caption
  },

  methods: {
    getGridTitle(grid) {
      return grid.title || null
    },
    getGridColumnDefs(grid) {
      return grid.columnDefs
    },
    getGridRowData(grid) {
      if (
        (this.isIssueUpdater || !this.isEditable) &&
        this.getGridSelections &&
        this.airlineTierTypeId !== COLLINS_PHM_TIER_3
      ) {
        return grid.rowData.filter(row => {
          return this.getGridSelections.includes(row.rowId)
        })
      } else {
        return grid.rowData
      }
    },
    hasGridFilters(grid) {
      const columnDefsHasFilter = grid.columnDefs.find(o =>
        Object.prototype.hasOwnProperty.call(o, 'filter'),
      )

      return (
        columnDefsHasFilter !== undefined &&
        grid.rowData &&
        grid.rowData.length > 1
      )
    },
    handlePreviewCaptionUpdate(value) {
      this.previewCaption = value
      this.$emit('onCaptionUpdate', {
        type: this.type,
        caption: value,
      })
    },
  },
}
</script>
